"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
(function (Drupal, once) {
  Drupal.behaviors.google_map = {
    attach: function attach(context, settings) {
      once('google-map', '.map--container', context).forEach(function (mapContainer) {
        var config = settings.dartHomeCampusMap || {};
        var locations = config.locations || [];
        if (!mapContainer || !locations.length) {
          return;
        }
        var initializeMap = function initializeMap() {
          var map;
          var gmarkers = [];
          var createLabelOnlyElement = function createLabelOnlyElement(text) {
            var isPrimary = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var div = document.createElement('div');
            div.className = 'map-label';
            if (isPrimary) {
              div.classList.add('map-label--primary');
            }
            div.innerText = text;
            return div;
          };
          var createSVGElement = function createSVGElement(svg, label) {
            var wrapper = document.createElement('div');
            wrapper.className = 'marker-with-label';
            var iconWrapper = document.createElement('div');
            iconWrapper.className = 'marker-icon';
            iconWrapper.innerHTML = svg;
            var labelEl = document.createElement('div');
            labelEl.className = 'marker-label';
            labelEl.innerText = label;
            wrapper.appendChild(iconWrapper);
            wrapper.appendChild(labelEl);
            return wrapper;
          };
          var setMarkers = function setMarkers(map, bounds) {
            return fetch('/themes/custom/darthome_2021/src/images/campus-map-pin.svg').then(function (res) {
              return res.text();
            }).then(function (svgString) {
              locations.forEach(function (location) {
                var _location = _slicedToArray(location, 6),
                  id = _location[0],
                  label = _location[1],
                  lat = _location[2],
                  lng = _location[3],
                  _location$ = _location[4],
                  icon = _location$ === void 0 ? null : _location$,
                  _location$2 = _location[5],
                  fontSize = _location$2 === void 0 ? null : _location$2;

                // Skip known built-in map features
                //if (label === 'Connecticut River') return;

                if (!lat || !lng || isNaN(lat) || isNaN(lng)) {
                  console.warn('Skipping invalid location:', location);
                  return;
                }
                var position = new google.maps.LatLng(lat, lng);
                var isLabelOnly = icon === '#empty';
                var isPrimaryLabel = fontSize === '18px';
                var content;
                if (isLabelOnly) {
                  content = createLabelOnlyElement(label, isPrimaryLabel);
                } else {
                  content = createSVGElement(svgString, label);
                }
                var marker = new google.maps.marker.AdvancedMarkerElement({
                  position: position,
                  content: content,
                  map: map
                });
                gmarkers.push(marker);
                bounds.extend(position);
              });
            });
          };
          var bounds = new google.maps.LatLngBounds();
          map = new google.maps.Map(mapContainer, {
            mapId: 'cf8d5a34f1a62979',
            disableDefaultUI: true,
            scrollwheel: false,
            draggable: true
          });
          setMarkers(map, bounds).then(function () {
            map.fitBounds(bounds, 0);
            window.addEventListener('resize', function () {
              map.fitBounds(bounds);
            });
          });
        };

        // Check if Maps API is already loaded
        if (window.google && window.google.maps && window.google.maps.Map) {
          initializeMap();
        } else {
          window._mapInitQueue = window._mapInitQueue || [];
          window._mapInitQueue.push(initializeMap);
          if (!window._mapScriptLoading) {
            window._mapScriptLoading = true;
            var script = document.createElement('script');
            script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBbVfUdnjXsmDUFI2AS6h-dMrBpcoJXgno&callback=mapInitLoader&libraries=marker';
            script.async = true;
            document.head.appendChild(script);
          }
          window.mapInitLoader = function () {
            window._mapInitQueue.forEach(function (fn) {
              return fn();
            });
            window._mapInitQueue = [];
          };
        }
      });
    }
  };
})(Drupal, once);